import React from "react";
import {
    Menu,
    MenuItem,
    ListItemIcon,
    // Typography,
    // Divider,
    // Box,
    // IconButton,
} from "@mui/material";
// import FolderOutlined from "@mui/icons-material/FolderOutlined";
// import MoveIcon from "@mui/icons-material/DriveFileMoveOutlined";
// import StarBorderIcon from "@mui/icons-material/StarBorder";
// import ShortcutIcon from "@mui/icons-material/Link";
// import CheckIcon from "@mui/icons-material/Check";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import TimelineOutlinedIcon from "@mui/icons-material/TimelineOutlined";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { useNavigate, useLocation } from "react-router-dom";
import { useTheme } from "../../style/theme";


const FolderInfoMenu = ({ anchorElSubMenu, handleSubMenuClose, setAnchorEl, handleOpenFIDetailActivityDialogModal, currentMenuClickedItem, handleOpenActivityTab }) => {
    // const [openDetail, setOpenDetail] = useState(false);
    const navigate = useNavigate(); // Get navigate function from React Router
    const location = useLocation();
    const { mode } = useTheme();

    const onClickSearch = () => {
        handleSubMenuClose(); // Close the menu first
        setAnchorEl(null)
        // Get current search params
        const searchParams = new URLSearchParams(location.search);

        // Set location (will replace if already exists)
        searchParams.set('location', currentMenuClickedItem._id);
        searchParams.set('locationName', currentMenuClickedItem.name);

        // Update URL
        navigate({
            search: searchParams.toString()
        });
    };


    return (
        <>
            <Menu
                anchorEl={anchorElSubMenu}
                open={Boolean(anchorElSubMenu)}
                onClose={handleSubMenuClose}  // This will handle clicks outside
                onClick={handleSubMenuClose}  // This will handle clicks inside
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: {
                        width: "340px",
                        borderRadius: "8px",
                        padding: "8px 0", 
                        boxShadow: "0px 4px 15px 0px rgba(0, 0, 0, 0.25)",
                        background: mode === 'dark' ? "rgba(31, 31, 31, 1)" : "rgb(255, 255, 255)",


                        mt: -1,
                        ml: `-${20}px`,
                    },
                }}
                MenuProps={{
                    disableAutoFocusItem: true,
                    PopperProps: {
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: { boundary: "window" },
                            },
                            {
                                name: "flip",
                                enabled: true,
                            },
                            {
                                name: "offset",
                                options: { offset: [0, 0] },
                            },
                        ],
                    },
                }}
            >
                {/* Standard Menu Items */}
                <MenuItem sx={{ padding: "10px 12px" }} onClick={handleOpenFIDetailActivityDialogModal}>
                    <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                        <InfoOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Detail
                </MenuItem>
                <MenuItem sx={{ padding: "10px 12px" }} onClick={handleOpenFIDetailActivityDialogModal}>
                    <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                        <SecurityOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Security Limitations
                </MenuItem>
                <MenuItem sx={{ padding: "10px 12px" }} onClick={handleOpenActivityTab}>
                    <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                        <TimelineOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Activity
                </MenuItem>

                <MenuItem sx={{ padding: "10px 12px" }}
                    onClick={onClickSearch}
                >
                    <ListItemIcon sx={{ minWidth: "20px",  mr: "0px" }}>
                        <SearchOutlinedIcon fontSize="small" />
                    </ListItemIcon>
                    Search within {currentMenuClickedItem.name}
                </MenuItem>




            </Menu>
        </>
    );
};

export default FolderInfoMenu;
